//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "vux";
import { mapState } from "vuex";
import { service, nativeApi } from "@/common/index";
import { fetch } from "@/page/index";
import { Dialog, Icon } from "vant";

export default {
  data() {
    return {
      showRespPicker: false,
      respColumns: [],
      showLanPicker: false,
      lanColumns: [],
    };
  },
  components: {},
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      responsibilityId: (state) => state.user.responsibilityId,
      languageCode: (state) => state.user.languageCode,
    }),
    responsibility: {
      get() {
        if (this.userInfo == null) {
          return "";
        }
        const role = this.userInfo.userRespList.find(
          (item) => item.responsibilityId === this.responsibilityId
        );
        return role != null ? role.responsibilityName : "";
      },
      set(val) {},
    },
    respIndex: {
      get() {
        return this.respColumns.findIndex(
          (item) => item.responsibilityId == this.responsibilityId
        );
      },
      set(val) {},
    },
    language: {
      get() {
        if (this.userInfo == null) {
          return "";
        }
        const lan = this.userInfo.languageList.find(
          (item) => item.lookupCode == this.languageCode
        );
        return lan != null ? lan.meaning : "";
      },
      set(val) {},
    },
    lanIndex: {
      get() {
        return this.lanColumns.findIndex(
          (item) => item.code == this.languageCode
        );
      },
      set(val) {},
    },
  },
  created() {},
  activated: function () {},
  methods: {
    /**初始化职责信息*/
    initResp() {
      //职责列表
      const respList = this.userInfo.userRespList.filter(
        (item) => item.systemCode === "MOBILE"
      );
      if (respList != null) {
        this.respColumns = respList.map((item) => {
          return {
            text: item.responsibilityName,
            responsibilityId: item.responsibilityId,
          };
        });
      }
      //语言列表
      const lanList = this.userInfo.languageList;
      if (lanList) {
        this.lanColumns = lanList.map((item) => {
          return {
            text: item.meaning,
            code: item.lookupCode,
          };
        });
      }
    },
    changeResp() {
      this.showRespPicker = true;
    },
    onConfirmResp(value) {
      this.showRespPicker = false;
      if (value == null) return;
      const respId = value.responsibilityId;
      this.$store.commit("SET_RESPONSIBILITY", respId);
    },
    onConfirmLan(value) {
      this.showLanPicker = false;
      if (value == null) return;
      const code = value.code;
      this.$store.commit("SET_LANGUAGE", code);
    },
    /**扫一扫*/
    doScan() {
      alert("扫一扫")
    },
  },
  watch: {},
  mounted() {
    this.initResp()
  },
};



// WEBPACK FOOTER //
// ./src/page/srm/home/UserHeader.vue